import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import RegisterPage from "./pages/RegisterPage";
import DemoPage from "./pages/DemoPage";
import DesignBenefitPlan from "./pages/DesignBenefitPlan";
import ScrollToTop from "./components/layout/ScrollToTop";

// Benefit Rails
import BenefitRailPage from "./pages/BenefitRails/BenefitRailPage";

// Calculators
import QuickCalculator from "./pages/Calculators/QuickCalculator";
import AdvancedCalculator from "./pages/Calculators/AdvancedCalculator";
import InsuranceCalculator from "./pages/Calculators/InsuranceCalculator";

// Admin
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminRates from "./pages/Admin/AdminRates";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/design-your-plan" element={<DesignBenefitPlan />} />

          {/* Benefit Rails */}
          <Route path="/rails/:railId" element={<BenefitRailPage />} />

          {/* Calculators */}
          <Route path="/calculators/quick" element={<QuickCalculator />} />
          <Route
            path="/calculators/advanced"
            element={<AdvancedCalculator />}
          />
          <Route
            path="/calculators/insurance"
            element={<InsuranceCalculator />}
          />

          {/* Admin */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/rates" element={<AdminRates />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
